import React from "react";
import { SelectInputComponent } from "../../../../common/components";
import { LEAD_STATUS_OPTIONS } from "../../../../constants/leadDropdown";
import "./filter-options-select.scss"
interface LeadStatusFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isLeadStatusEnabled?: boolean;
  leadStatusError?: any;
}

const LeadStatusFilter: React.FC<LeadStatusFilterProps> = ({
  value,
  onChange,
  isLeadStatusEnabled,
  leadStatusError
}) => {
  if (!isLeadStatusEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="status"
        options={LEAD_STATUS_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Lead Status"
        multiple={true}
        isFilter={true}
      />
      {leadStatusError && <div className="error-text">{leadStatusError}</div>}
    </div>
  );
};

export default LeadStatusFilter;
